import {useQuery, useQueryClient} from "@tanstack/react-query";
import {UserRankData, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

interface LeaderboardResponse {
    users: UserRankData[];
    total: number;
}

async function fetchLeaderboard(limit: number, offset: number): Promise<LeaderboardResponse> {
    const data = await new UsersApi(getConfig()).getUsersTopLeaderboardRanks({limit, offset});
    return data as unknown as LeaderboardResponse;
}

export function useGetXPLeaderboard(limit = 50, offset = 0, enabled = true) {
    return useQuery({
        queryKey: ["xp-leaderboard", limit, offset],
        queryFn: () => fetchLeaderboard(limit, offset),
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
        enabled,
    });
}

/**
 * Prefetch the next page of XP leaderboard data for smooth pagination.
 */
export function usePrefetchNextXPLeaderboardPage(limit: number, offset: number, total: number) {
    const queryClient = useQueryClient();

    return () => {
        const nextOffset = offset + limit;
        if (nextOffset < total) {
            void queryClient.prefetchQuery({
                queryKey: ["xp-leaderboard", limit, nextOffset],
                queryFn: () => fetchLeaderboard(limit, nextOffset),
                staleTime: 30 * 1000,
            });
        }
    };
}
